export { default } from './TooltipOverflowText';
